module.exports = __webpack_public_path__ + "static/tat-11-529fab40714d3f8aa4eaf82bace64cf0.jpg";